import React from "react";
import { makeStyles, Paper, Grid } from "@material-ui/core";
import { i18n } from "../../../translate/i18n";
import InfoTip from "./InfoTip";

const WA_GREEN = "#00a884";
const TV_DARK = "#1e2a3a";

const useStyles = makeStyles((theme) => ({
  cardBig: {
    padding: theme.spacing(2.5),
    background: WA_GREEN,
    color: "#fff",
    height: "100%",
  },
  card: { padding: theme.spacing(2.5), height: "100%" },
  cardValue: { fontSize: 40, fontWeight: 700, lineHeight: 1.1 },
  cardLabel: { fontSize: 12, textTransform: "uppercase", opacity: 0.75 },
}));

const pct = (frac) => `${Math.round((frac ?? 0) * 100)}%`;

const KpiCards = ({ roi, counts, show, isTV = false }) => {
  const classes = useStyles();

  const cards = [
    {
      flag: "horasAhorradas",
      tip: "horasAhorradas",
      big: true,
      value: roi?.horasAhorradas ?? 0,
      label: i18n.t("aiAssistantStats.cards.horasAhorradas"),
    },
    {
      flag: "cobertura",
      tip: "cobertura",
      value: pct(roi?.cobertura?.fueraHorarioPct),
      label: i18n.t("aiAssistantStats.cards.cobertura"),
    },
    {
      flag: "reclamosATiempo",
      tip: "reclamosATiempo",
      value: counts?.reclamosDetectados ?? 0,
      label: i18n.t("aiAssistantStats.cards.reclamos"),
    },
    {
      flag: "iaVsHumano",
      tip: "iaVsHumano",
      value: `${counts?.iaMessages ?? 0}/${counts?.humanMessages ?? 0}`,
      label: i18n.t("aiAssistantStats.cards.iaVsHumano"),
    },
  ].filter((c) => show(c.flag));

  if (isTV) {
    return (
      <div style={{ display: "flex", gap: 12 }}>
        {cards.map(({ flag, big, value, label }) => (
          <div
            key={flag}
            style={{
              flex: 1,
              padding: "10px 16px",
              background: big ? WA_GREEN : TV_DARK,
              borderRadius: 8,
              border: "1px solid rgba(255,255,255,0.12)",
            }}
          >
            <div style={{ fontSize: 11, textTransform: "uppercase", opacity: 0.65, color: "#fff" }}>
              {label}
            </div>
            <div style={{ fontSize: 34, fontWeight: 800, color: "#fff", lineHeight: 1.2 }}>
              {value}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <Grid container spacing={2}>
      {cards.map(({ flag, tip, big, value, label }) => (
        <Grid item xs={6} sm={3} key={flag}>
          <Paper className={big ? classes.cardBig : classes.card} elevation={big ? 3 : 2}>
            <div className={classes.cardLabel}>
              {label}
              <InfoTip tipKey={tip} isTV={isTV} />
            </div>
            <div className={classes.cardValue}>{value}</div>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default KpiCards;
